/**
 * Copyright 2020 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useEffect, useState } from 'react';
import Script from 'next/script';
import { useLocale } from '@/hooks/useLocale';
import { countryCodes } from '@/constants/locale';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useProductDetails } from '@/features/product/api/getProductDetails';
import environmentConfig from '@/config/environment';
import { useAppData } from '@/hooks/useAppData';

export const BazaarVoiceQuestions = () => {
  const { appData } = useAppData();
  const { deviceType } = appData;
  const isABot = deviceType === 'bot';
  const isTabletOrBelow = useMediaQuery((theme) => theme.breakpoints.between(0, 1139));
  const [queryEnabled, setQueryEnabled] = useState(isABot);
  const { data: productDetails } = useProductDetails({ enabled: queryEnabled });
  const locale = useLocale();
  const { BV_MOBILE_TAG, BV_DESKTOP_TAG } = environmentConfig;

  useEffect(() => {
    const handleEnableQuery = () => {
      setQueryEnabled(true);
      window.removeEventListener('scroll', handleEnableQuery);
    };

    if (!isABot) {
      window.addEventListener('scroll', handleEnableQuery);
    }

    return () => {
      window.removeEventListener('scroll', handleEnableQuery);
    };
  }, [isABot]);

  const bvQuestionsContent = productDetails?.product?.itemId ? (
    <div id="tab-questions">
      <div data-bv-show="questions" data-bv-product-id={productDetails.product.itemId} />
    </div>
  ) : null;

  const customHeaderScript = isTabletOrBelow ? BV_MOBILE_TAG : BV_DESKTOP_TAG;

  return locale === countryCodes.us && !!queryEnabled ? (
    <div id="bv_PDPQuestions">
      {bvQuestionsContent}
      {customHeaderScript ? <Script src={customHeaderScript} strategy="lazyOnload" /> : null}
    </div>
  ) : null;
};
